/* Phos Light: intro, scroll-lit hero, light cards, torch, scratch popup. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover)').matches;
  function store(kind) { try { return window[kind]; } catch (e) { return null; } }
  function get(kind, k) { try { var s = store(kind); return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function set(kind, k, v) { try { var s = store(kind); if (s) s.setItem(k, v); } catch (e) {} }
  var bus = { introDone: !root.classList.contains('phos-intro-on'), waiters: [] };
  function afterIntro(fn) { if (bus.introDone) fn(); else bus.waiters.push(fn); }

  /* ---------------- First Light intro ---------------- */
  function initIntro() {
    var el = document.querySelector('.phos-intro');
    if (!el || !root.classList.contains('phos-intro-on')) {
      requestAnimationFrame(function () { requestAnimationFrame(heroIn); });
      finishIntro(); return;
    }
    var done = false, timer;
    function end() {
      if (done) return; done = true;
      clearTimeout(timer);
      root.classList.remove('phos-intro-on', 'phos-intro-play');
      set('sessionStorage', 'phos-intro-seen', '1');
      heroIn();
      finishIntro();
    }
    function start() {
      root.classList.add('phos-intro-play');
      setTimeout(heroIn, 1500);
      timer = setTimeout(end, 2600);
    }
    el.addEventListener('click', end);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') end(); }, { once: true });
    var img = el.querySelector('img');
    if (img && !img.complete) { img.addEventListener('load', start, { once: true }); img.addEventListener('error', start, { once: true }); setTimeout(function () { if (!root.classList.contains('phos-intro-play')) start(); }, 450); }
    else start();
  }
  function heroIn() { root.classList.add('phos-hero-in'); }
  function finishIntro() {
    bus.introDone = true;
    bus.waiters.splice(0).forEach(function (fn) { try { fn(); } catch (e) {} });
  }

  /* ---------------- scroll-lit hero ---------------- */
  function initHero(sec) {
    var data;
    try { data = JSON.parse(sec.querySelector('script[data-phos-frames]').textContent); } catch (e) { return; }
    var portrait = window.matchMedia('(max-aspect-ratio: 4/5)');
    var canvas = sec.querySelector('canvas'), ctx = canvas.getContext('2d');
    var sticky = sec.querySelector('.phos-hero__sticky');
    var list = [], imgs = [], ready = [], cur = -1, raf = 0, w = 0, h = 0, started = false;

    function pick() {
      var dm = (data.m || []).filter(Boolean), dd = (data.d || []).filter(Boolean);
      var next = (portrait.matches && dm.length) ? dm : (dd.length ? dd : dm);
      if (next.length && list.length && next[0] === list[0]) return;
      list = next; imgs = new Array(list.length); ready = new Array(list.length).fill(false); cur = -1;
      load();
    }
    function loadOne(i) {
      if (imgs[i]) return;
      var im = new Image(); im.decoding = 'async';
      im.onload = function () { ready[i] = true; if (i === 0 || Math.abs(i - cur) < 2) draw(true); };
      im.src = list[i]; imgs[i] = im;
    }
    function load() {
      if (!list.length) return;
      loadOne(0);
      var order = [];
      for (var step = 8; step >= 1; step = step / 2) for (var i = 0; i < list.length; i += step) if (order.indexOf(i) < 0) order.push(i);
      var k = 0;
      (function pump() {
        var n = 0;
        while (k < order.length && n < 6) { loadOne(order[k++]); n++; }
        if (k < order.length) setTimeout(pump, 120);
      })();
    }
    function size() {
      var r = sticky.getBoundingClientRect(), d = Math.min(2, window.devicePixelRatio || 1);
      w = Math.round(r.width * d); h = Math.round(r.height * d);
      if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; }
      draw(true);
    }
    function nearest(i) {
      if (ready[i]) return i;
      for (var o = 1; o < list.length; o++) { if (ready[i - o]) return i - o; if (ready[i + o]) return i + o; }
      return -1;
    }
    function cover(im, alpha) {
      var s = Math.max(w / im.naturalWidth, h / im.naturalHeight);
      var dw = im.naturalWidth * s, dh = im.naturalHeight * s;
      var fx = portrait.matches ? 0.5 : 0.62, fy = 0.5;
      var x = (w - dw) * fx, y = (h - dh) * fy;
      if (portrait.matches) y += h * 0.10;
      ctx.globalAlpha = alpha; ctx.drawImage(im, x, y, dw, dh); ctx.globalAlpha = 1;
    }
    function progress() {
      var r = sec.getBoundingClientRect();
      var total = r.height - sticky.offsetHeight;
      return total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
    }
    function draw(force) {
      if (!list.length || !w) return;
      var p = progress();
      if (p > 0.01 && !started) { started = true; sec.setAttribute('data-progress-started', ''); }
      var f = p * (list.length - 1), i = Math.floor(f), t = f - i;
      var a = nearest(i); if (a < 0) return;
      var key = i + t;
      if (!force && Math.abs(key - cur) < 0.002) return;
      cur = key;
      ctx.clearRect(0, 0, w, h);
      cover(imgs[a], 1);
      var b = i + 1 < list.length && ready[i + 1] ? i + 1 : -1;
      if (b >= 0 && t > 0.001 && a === i) cover(imgs[b], t);
      canvas.style.opacity = '1';
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(function () { raf = 0; draw(false); }); }
    canvas.style.opacity = '0';
    pick(); size();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { pick(); size(); });
    if (portrait.addEventListener) portrait.addEventListener('change', function () { pick(); size(); });
  }

  /* ---------------- hero light film (plays by itself) ---------------- */
  function initHeroVideo(sec) {
    var v = sec.querySelector('video');
    if (!v) return;
    var portrait = window.matchMedia('(max-aspect-ratio: 4/5)');
    var visible = true, wanted = false;
    var hevc = false; try { hevc = !!v.canPlayType && /probably|maybe/.test(v.canPlayType('video/mp4; codecs="hvc1"')); } catch (e) {}
    function src() {
      var k = portrait.matches ? 'data-src-m' : 'data-src-d';
      return (hevc && v.getAttribute(k + '-hevc')) || v.getAttribute(k);
    }
    function load() {
      var s = src();
      if (v.getAttribute('src') !== s) { v.classList.remove('is-playing'); v.setAttribute('src', s); v.load(); }
    }
    function play() {
      if (reduce || !visible || !wanted) return;
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    }
    v.addEventListener('playing', function () { v.classList.add('is-playing'); });
    load();
    wanted = true; play(); /* start the light sweep immediately, even while the intro plays */
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) {
      visible = es[0].isIntersecting; if (visible) play(); else v.pause();
    }, { threshold: 0.05 }).observe(sec);
    var onChange = function () { load(); play(); };
    if (portrait.addEventListener) portrait.addEventListener('change', onChange);
    window.addEventListener('scroll', function () { if (scrollY > 20) sec.setAttribute('data-progress-started', ''); }, { passive: true });
  }

  /* ---------------- calm reveal on scroll ---------------- */
  function initReveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var SEL = '.phos-head, .phos-tile, .phos-line, .phos-promise > div, .phos-founder blockquote, .phos-founder cite, .phos-signup .phos-form, .phos-compare, .phos-lt__tile, .phos-lt__row, .phos-banner, .phos-feat, .phos-ms, .phos-torch__copy .phos-wrap > *, .product-card';
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    function prep(root) {
      var els = (root || document).querySelectorAll(SEL);
      els.forEach(function (el) {
        if (el.classList.contains('phos-reveal') || el.closest('.phos-hero, .phos-pop, .header, header-component, .predictive-search, .quick-add-modal')) return;
        var sibs = el.parentElement ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.matches(SEL); }) : [];
        var idx = Math.max(0, sibs.indexOf(el));
        el.style.setProperty('--phos-d', Math.min(idx, 5) * 90 + 'ms');
        var r = el.getBoundingClientRect();
        el.classList.add('phos-reveal');
        if (r.top < innerHeight * 0.94 && r.bottom > 0) { el.classList.add('is-in', 'is-now'); requestAnimationFrame(function () { el.classList.remove('is-now'); }); }
        else io.observe(el);
      });
    }
    prep();
    root.classList.add('phos-js');
    new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) prep(n.parentElement || n); }); }); })
      .observe(document.body, { childList: true, subtree: true });
  }

  /* ---------------- torch ---------------- */
  function initTorch(el) {
    var last = 0;
    function setXY(x, y) { el.style.setProperty('--x', x + 'px'); el.style.setProperty('--y', y + 'px'); }
    el.addEventListener('pointermove', function (e) { var r = el.getBoundingClientRect(); setXY(e.clientX - r.left, e.clientY - r.top); last = performance.now(); });
    if (reduce) { el.style.setProperty('--x', '60%'); return; }
    var on = false;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { on = es[0].isIntersecting; if (on) requestAnimationFrame(drift); }).observe(el);
    function drift(now) {
      if (!on) return;
      if (now - last > 1600) {
        var r = el.getBoundingClientRect(), t = now / 1000;
        setXY(r.width * (0.55 + 0.32 * Math.sin(t * 0.42)), r.height * (0.45 + 0.25 * Math.sin(t * 0.77 + 1)));
      }
      requestAnimationFrame(drift);
    }
  }

  /* ---------------- scratch card ---------------- */
  function scratch(card, onReveal) {
    var cv = card.querySelector('canvas'), torch = card.querySelector('.phos-scard__torch');
    if (!cv) return { reveal: function () {} };
    var ctx = cv.getContext('2d'), done = false, moves = 0, drawing = false, last = null;
    function size() {
      var r = card.getBoundingClientRect(), d = Math.min(2, window.devicePixelRatio || 1);
      if (!r.width) return;
      cv.width = Math.round(r.width * d); cv.height = Math.round(r.height * d); paint();
    }
    function paint() {
      if (done) return;
      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = '#030304'; ctx.fillRect(0, 0, cv.width, cv.height);
      var n = Math.round(cv.width * cv.height / 900);
      for (var i = 0; i < n; i++) { ctx.fillStyle = 'rgba(255,255,255,' + (Math.random() * 0.035).toFixed(3) + ')'; ctx.fillRect(Math.random() * cv.width, Math.random() * cv.height, 1.5, 1.5); }
      ctx.fillStyle = 'rgba(236,231,223,.28)';
      ctx.font = '500 ' + Math.max(10, Math.round(cv.width * 0.026)) + 'px "Phos Mono", ui-monospace, monospace';
      ctx.textAlign = 'center';
      ctx.fillText(card.getAttribute('data-label') || 'SHINE YOUR LIGHT HERE', cv.width / 2, cv.height / 2 + cv.width * 0.01);
    }
    function pos(e) { var r = cv.getBoundingClientRect(); return { x: (e.clientX - r.left) * cv.width / r.width, y: (e.clientY - r.top) * cv.height / r.height, cx: e.clientX - r.left, cy: e.clientY - r.top }; }
    function erase(p) {
      var rad = cv.width * 0.08, pts = [p];
      ctx.globalCompositeOperation = 'destination-out';
      if (last) { var n = Math.ceil(Math.hypot(p.x - last.x, p.y - last.y) / (rad * 0.35)); for (var k = 1; k < n; k++) pts.push({ x: last.x + (p.x - last.x) * k / n, y: last.y + (p.y - last.y) * k / n }); }
      pts.forEach(function (q) {
        var g = ctx.createRadialGradient(q.x, q.y, 0, q.x, q.y, rad);
        g.addColorStop(0, 'rgba(0,0,0,1)'); g.addColorStop(.6, 'rgba(0,0,0,.85)'); g.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(q.x, q.y, rad, 0, Math.PI * 2); ctx.fill();
      });
      last = p;
      if (++moves % 10 === 0) check();
    }
    function check() {
      var w = 64, h = 36, off = document.createElement('canvas'); off.width = w; off.height = h;
      var o = off.getContext('2d'); o.drawImage(cv, 0, 0, w, h);
      var d, clear = 0;
      try { d = o.getImageData(0, 0, w, h).data; } catch (e) { if (moves > 60) reveal(); return; }
      for (var i = 3; i < d.length; i += 4) if (d[i] < 90) clear++;
      if (clear / (w * h) > 0.45) reveal();
    }
    function reveal() {
      if (done) return; done = true;
      cv.style.opacity = '0'; setTimeout(function () { cv.hidden = true; }, 650);
      card.classList.add('phos-lit');
      if (onReveal) onReveal();
    }
    cv.addEventListener('pointerdown', function (e) { drawing = true; last = null; card.setAttribute('data-touching', ''); try { cv.setPointerCapture(e.pointerId); } catch (x) {} erase(pos(e)); });
    cv.addEventListener('pointermove', function (e) {
      var p = pos(e);
      if (torch) { torch.style.left = p.cx + 'px'; torch.style.top = p.cy + 'px'; }
      if (drawing || e.pointerType === 'mouse') erase(p);
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) { cv.addEventListener(ev, function () { drawing = false; last = null; card.removeAttribute('data-touching'); }); });
    window.addEventListener('resize', function () { if (!done) size(); });
    return { size: size, reveal: reveal };
  }

  function initPopup() {
    var pop = document.getElementById('PhosPop');
    if (!pop) return;
    var teaser = document.getElementById('PhosTeaser');
    var DAY = 864e5;
    var posted = !!pop.querySelector('[data-phos-success]') && get('sessionStorage', 'phos-pop-submitted') === '1';
    var joined = get('localStorage', 'phos-joined') === '1';
    var closedAt = +(get('localStorage', 'phos-pop-closed') || 0);
    var hint = pop.querySelector('[data-phos-hint]');
    var form = pop.querySelector('form');
    var sc = scratch(pop.querySelector('.phos-scard'), function () {
      if (hint) hint.textContent = hint.getAttribute('data-after') || hint.textContent;
      var rv = pop.querySelector('[data-phos-reveal]'); if (rv) rv.hidden = true;
      var em = pop.querySelector('input[type=email]'); if (em && canHover) em.focus({ preventScroll: true });
      pop.setAttribute('data-revealed', '');
    });
    var lastFocus = null;
    function open() {
      if (pop.hasAttribute('data-open')) return;
      lastFocus = document.activeElement;
      pop.setAttribute('data-open', ''); if (teaser) teaser.removeAttribute('data-show');
      requestAnimationFrame(function () { pop.setAttribute('data-show', ''); sc.size && sc.size(); var x = pop.querySelector('.phos-pop__x'); if (x) x.focus({ preventScroll: true }); });
      document.addEventListener('keydown', esc);
    }
    function close(remember) {
      pop.removeAttribute('data-show');
      setTimeout(function () { pop.removeAttribute('data-open'); }, 350);
      document.removeEventListener('keydown', esc);
      if (remember) set('localStorage', 'phos-pop-closed', String(Date.now()));
      if (teaser && get('localStorage', 'phos-joined') !== '1') teaser.setAttribute('data-show', '');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    function esc(e) { if (e.key === 'Escape') close(true); }
    pop.querySelectorAll('[data-phos-close]').forEach(function (b) { b.addEventListener('click', function () { close(true); }); });
    var rv = pop.querySelector('[data-phos-reveal]'); if (rv) rv.addEventListener('click', function () { sc.reveal(); });
    if (teaser) teaser.addEventListener('click', open);
    if (form) form.addEventListener('submit', function (e) {
      var em = form.querySelector('input[type=email]'), msg = form.querySelector('[data-phos-msg]');
      if (!pop.hasAttribute('data-revealed')) { e.preventDefault(); if (msg) { msg.className = 'phos-msg phos-msg--err'; msg.textContent = 'Shine your light across the card first.'; } return; }
      if (!em || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em.value)) { e.preventDefault(); if (msg) { msg.className = 'phos-msg phos-msg--err'; msg.textContent = 'Enter a full email address, like name@example.com.'; } em && em.focus(); return; }
      set('localStorage', 'phos-joined', '1');
      set('sessionStorage', 'phos-pop-submitted', '1');
    });
    if (pop.querySelector('[data-phos-errors]')) { afterIntro(function () { open(); sc.reveal(); }); return; }
    if (posted) {
      set('localStorage', 'phos-joined', '1');
      set('sessionStorage', 'phos-pop-submitted', '0');
      afterIntro(function () { pop.setAttribute('data-success', ''); open(); });
      return;
    }
    if (joined || pop.getAttribute('data-enabled') !== 'true') return;
    if (closedAt && Date.now() - closedAt < 14 * DAY) { if (teaser) afterIntro(function () { teaser.setAttribute('data-show', ''); }); return; }
    var delay = +(pop.getAttribute('data-delay') || 15) * 1000, fired = false;
    function fire() { if (fired) return; fired = true; window.removeEventListener('scroll', onS); open(); }
    function onS() { var max = document.documentElement.scrollHeight - innerHeight; if (max > 0 && scrollY / max > 0.5) fire(); }
    afterIntro(function () {
      setTimeout(fire, delay);
      window.addEventListener('scroll', onS, { passive: true });
      if (canHover) document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 8) fire(); });
    });
  }

  function initCopy() {
    document.querySelectorAll('[data-phos-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-phos-copy');
        var ok = function () { b.textContent = 'Copied'; setTimeout(function () { b.textContent = 'Copy'; }, 1800); };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(ok, function () {}); else ok();
      });
    });
  }

  function initForms() {
    document.querySelectorAll('form.phos-form').forEach(function (f) {
      f.addEventListener('submit', function () { set('localStorage', 'phos-joined', '1'); });
    });
    if (document.querySelector('[data-phos-success]')) set('localStorage', 'phos-joined', '1');
  }

  function boot() {
    initIntro();
    document.querySelectorAll('[data-phos-hero]').forEach(function (sec) { if (sec.getAttribute('data-mode') === 'video') initHeroVideo(sec); else initHero(sec); });
    document.querySelectorAll('[data-phos-torch]').forEach(initTorch);
    initReveal();
    initForms();
    initPopup();
    initCopy();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* Phos light test: live-shaded real forged carbon vs a printed copy of the same pattern. */
(function () {
  var VS = 'attribute vec2 p; varying vec2 vUv; void main(){ vUv = p * 0.5 + 0.5; gl_Position = vec4(p, 0.0, 1.0); }';
  var FS = [
    'precision highp float;',
    'uniform sampler2D uMap; uniform vec2 uMapPx; uniform vec2 uOff; uniform vec2 uScale;',
    'uniform float uLight; uniform float uAsp; uniform float uMode; uniform float uTime; uniform float uTexel;',
    'varying vec2 vUv;',
    'float h1(float n){ return fract(sin(n) * 43758.5453); }',
    'void main(){',
    '  vec2 uv = uOff + vec2(vUv.x, 1.0 - vUv.y) * uScale;',
    '  vec3 m = texture2D(uMap, uv).rgb;',
    '  float ang = m.r * 3.14159265; float tilt = (m.g - 0.5) * 1.2; float grey = m.b;',
    '  float rnd = h1(m.r * 917.0 + m.g * 131.0 + m.b * 17.0);',
    '  vec2 T = vec2(cos(ang), -sin(ang)); vec2 A = vec2(-T.y, T.x);',
    '  vec2 P = vec2(vUv.x * uAsp, vUv.y);',
    '  float lx = uLight * uAsp;',
    '  float seam = smoothstep(0.02, 0.10, grey);',
    '  vec3 warm = vec3(1.0, 0.95, 0.87);',
    '  /* resin clear-coat: the strip mirrored in a flat gloss surface (same on both sides) */',
    '  float dx = P.x - lx;',
    '  float cc = exp(-dx * dx / (2.0 * 0.010 * 0.010)) * 0.55 + exp(-dx * dx / (2.0 * 0.05 * 0.05)) * 0.07;',
    '  vec3 col;',
    '  if (uMode > 0.5) {',
    '    vec2 px = uv * uMapPx;',
    '    float across = dot(px, A);',
    '    float s1 = 0.5 + 0.5 * sin(across * 1.55 + rnd * 60.0 + sin(dot(px, T) * 0.03 + rnd * 9.0) * 2.2);',
    '    float s2 = 0.5 + 0.5 * sin(across * 0.23 + rnd * 23.0);',
    '    float stri = mix(0.42, 1.0, s1) * mix(0.5, 1.0, s2 * s2);',
    '    stri = mix(0.72, stri, clamp(1.6 - uTexel * 0.6, 0.0, 1.0));',
    '    /* each shard is tilted, so its glint arrives at its own point in the sweep */',
    '    float shift = tilt * A.x * 0.75 + (rnd - 0.5) * 0.16;',
    '    float along = abs(T.y);',
    '    float w = mix(0.018, 0.11, along * along);',
    '    float d = dx - shift;',
    '    float g = exp(-d * d / (2.0 * w * w));',
    '    float gloss = pow(rnd, 1.6) * 1.15 + 0.12;',
    '    float fib = g * gloss * stri * seam;',
    '    float sheen = exp(-dx * dx / (2.0 * 0.16 * 0.16)) * 0.012 * seam;',
    '    float base = (0.0028 + 0.0055 * grey) * mix(0.55, 1.0, seam);',
    '    col = vec3(base) * vec3(0.95, 0.97, 1.0) + warm * (fib * 0.95 + sheen) + warm * cc * 0.55;',
    '  } else {',
    '    /* printed copy: the same pattern as a flat photo; light only adds one even glare band */',
    '    float print = (0.006 + 0.022 * grey) * mix(0.6, 1.0, seam);',
    '    float glare = exp(-dx * dx / (2.0 * 0.12 * 0.12));',
    '    col = vec3(print) * vec3(0.96, 0.97, 1.0) * (1.0 + glare * 0.8) + warm * (glare * 0.035 + cc * 0.5);',
    '  }',
    '  float vig = 1.0 - 0.35 * pow(length((vUv - 0.5) * vec2(1.1, 1.3)), 2.0);',
    '  col *= vig;',
    '  col = col / (1.0 + col * 0.35);',
    '  col = pow(col, vec3(1.0 / 2.2));',
    '  gl_FragColor = vec4(col, 1.0);',
    '}'
  ].join('\n');

  function make(canvas, img, mode) {
    var gl = canvas.getContext('webgl', { antialias: false, premultipliedAlpha: false, preserveDrawingBuffer: false });
    if (!gl) return null;
    function sh(t, s) { var o = gl.createShader(t); gl.shaderSource(o, s); gl.compileShader(o); if (!gl.getShaderParameter(o, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(o)); return o; }
    var pr = gl.createProgram(); gl.attachShader(pr, sh(gl.VERTEX_SHADER, VS)); gl.attachShader(pr, sh(gl.FRAGMENT_SHADER, FS)); gl.linkProgram(pr); gl.useProgram(pr);
    var b = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, b); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    var tex = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, gl.NONE);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, img);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    var U = {}; ['uMap', 'uMapPx', 'uOff', 'uScale', 'uLight', 'uAsp', 'uMode', 'uTime', 'uTexel'].forEach(function (n) { U[n] = gl.getUniformLocation(pr, n); });
    gl.uniform1i(U.uMap, 0); gl.uniform2f(U.uMapPx, img.naturalWidth || img.width, img.naturalHeight || img.height); gl.uniform1f(U.uMode, mode);
    return {
      size: function () {
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var w = Math.max(1, Math.round(canvas.clientWidth * dpr)), h = Math.max(1, Math.round(canvas.clientHeight * dpr));
        if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; }
        gl.viewport(0, 0, w, h);
        var asp = canvas.clientWidth / Math.max(1, canvas.clientHeight);
        /* show a crop sized to the tile so shards read at a similar physical size on phone and desktop */
        var zoom = Math.max(0.3, Math.min(1.0, canvas.clientWidth / 620));
        var sx = zoom, sy = zoom / asp; if (sy > 1) { sx /= sy; sy = 1; }
        gl.uniform2f(U.uScale, sx, sy); gl.uniform2f(U.uOff, (1 - sx) * 0.5, (1 - sy) * 0.5); gl.uniform1f(U.uAsp, asp);
        gl.uniform1f(U.uTexel, (sx * (img.naturalWidth || img.width)) / w);
      },
      draw: function (light, t) { gl.uniform1f(U.uLight, light); gl.uniform1f(U.uTime, t || 0); gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4); }
    };
  }

  window.phosLightTest = function (sec) {
    var stage = sec.querySelector('.phos-lt__stage'); if (!stage) return;
    var canvases = stage.querySelectorAll('canvas');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var img = new Image(); img.decoding = 'async';
    var views = [], light = 0.5, target = 0.5, auto = true, autoT = 0, raf = 0, visible = false, lastUser = 0, started = false;
    function start() {
      if (started) return; started = true;
      img.onload = function () {
        try { views = Array.prototype.map.call(canvases, function (c) { return make(c, img, c.getAttribute('data-mode') === 'print' ? 0 : 1); }).filter(Boolean); } catch (e) { views = []; }
        if (!views.length) { sec.classList.add('phos-lt--static'); return; }
        sec.classList.add('phos-lt--live');
        resize(); kick();
      };
      img.src = stage.getAttribute('data-map');
    }
    function resize() { views.forEach(function (v) { v.size(); }); render(); }
    function render() { views.forEach(function (v) { v.draw(light); }); }
    function tick(now) {
      raf = 0;
      if (auto && !reduce) { autoT += 1 / 60; target = 0.5 + 0.62 * Math.sin(autoT * 0.55); }
      light += (target - light) * (auto ? 0.12 : 0.18);
      render();
      if (visible && (auto ? !reduce : Math.abs(target - light) > 0.0005)) raf = requestAnimationFrame(tick);
      if (!auto && performance.now() - lastUser > 2600) { auto = true; autoT = Math.asin(Math.max(-1, Math.min(1, (light - 0.5) / 0.62))) / 0.55; kick(); }
    }
    function kick() { if (!raf && visible && views.length) raf = requestAnimationFrame(tick); }
    function point(clientX) {
      var r = stage.getBoundingClientRect(); var x = (clientX - r.left) / r.width;
      /* one beam crosses both tiles: map stage x to each tile's local x via the tile it is over */
      auto = false; lastUser = performance.now();
      /* the same light sits over both tiles, so you compare like for like */
      target = Math.max(-0.1, Math.min(1.1, x > 0.5 ? (x - 0.5) * 2 : x * 2));
      kick();
    }
    stage.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse' || e.buttons) point(e.clientX); });
    stage.addEventListener('pointerdown', function (e) { point(e.clientX); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) start(); visible = e.isIntersecting; if (visible) kick(); });
    }, { rootMargin: '300px 0px' }).observe(sec);
    else { start(); visible = true; }
    window.addEventListener('resize', function () { if (views.length) resize(); });
    sec.phosSetLight = function (v) { auto = false; light = target = v; lastUser = performance.now() + 1e9; render(); };
  };
})();

(function () {
  function go() { document.querySelectorAll('[data-phos-lighttest]').forEach(function (s) { try { window.phosLightTest(s); } catch (e) {} }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();

/* Phos: estimated delivery dates + 'Choose your model' scrolls back to the buy box */
(function () {
  function go() {
    var els = document.querySelectorAll('[data-phos-eta]');
    if (els.length) {
      var fmt = function (d) { try { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); } catch (e) { return d.toDateString().slice(4, 10); } };
      /* lead time: 7-14 business days to ship + 3-7 business days delivery = 10-21 business days */
      var addBiz = function (d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; };
      var now = new Date(), a = addBiz(now, 10), b = addBiz(now, 21);
      els.forEach(function (el) { el.textContent = fmt(a) + ' – ' + fmt(b); });
    }
    document.querySelectorAll('[data-phos-totop]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.querySelector('.product-details variant-picker, .product-details .variant-picker, .product-details');
        if (!t) return; e.preventDefault();
        var y = t.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.body).getPropertyValue('--header-height')) || 80) - 16;
        window.scrollTo({ top: y, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();

/* Phos: round color swatches for products with their own Color option (iPhone Duo) drive the hidden variant picker */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-phos-color]');
    if (!b) return;
    e.preventDefault();
    var val = b.getAttribute('data-phos-color');
    var wrap = b.closest('[data-phos-optcolors]');
    var scope = b.closest('.product-details') || document;
    var inputs = scope.querySelectorAll('input[type="radio"][name^="Color-"]');
    var inp = null;
    for (var i = 0; i < inputs.length; i++) { if (inputs[i].value === val) { inp = inputs[i]; break; } }
    if (wrap) {
      wrap.querySelectorAll('[data-phos-color]').forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      var nm = wrap.querySelector('[data-phos-colorname]'); if (nm) nm.textContent = val;
    }
    if (inp && !inp.checked) inp.click();
  });
})();
